import { render, staticRenderFns } from "./CreateVoucher.vue?vue&type=template&id=148c29e5&scoped=true&"
import script from "./CreateVoucher.vue?vue&type=script&lang=js&"
export * from "./CreateVoucher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148c29e5",
  null
  
)

export default component.exports